/**
 * KwUcretliUyari.jsx — the notice under the electricity kW input (backlog #456, 2026-10-17; backend #455).
 *
 * Shows, from the check the backend sends on the Elektrik row (`kwKontrol`, see kwKontrol.js):
 *  · while the request is within the allowance: how many kW the fair gives free for this stand (a quiet line), so the exhibitor knows the limit before typing;
 *  · as soon as the requested kW is ABOVE it: a warning that the excess is charged. The request is still saved (a warning, never a refusal);
 *  · and, when the backend returned the organizer's payment link, a "Pay" button that opens it in a NEW tab (rel="noopener noreferrer") with the link's host
 *    written next to it so the exhibitor sees where it goes. The link is re-checked here (https only) before a button is drawn.
 *
 * @param {object}  kwKontrol  the Elektrik row's `kwKontrol` (null / absent = nothing is drawn)
 * @param {*}       istenenKw  the kW being typed (or the saved value); a form value or a number
 * @param {boolean} etkin      false = nothing is drawn (the electricity switch is off)
 */
import React from "react";
import { Alert } from "reactstrap";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { currentLocaleTag } from "../../i18n";
import { guvenliOdemeBaglantisi, kwAsimi, kwYazi } from "./kwKontrol";

export default function KwUcretliUyari({ kwKontrol, istenenKw, etkin = true }) {
  const { t } = useTranslation("portal");
  const a = kwAsimi(kwKontrol, istenenKw);
  if (!etkin || a.serbest === null) return null;
  const yerel = currentLocaleTag();

  if (!a.ucretli) {
    return (
      <div className="small text-muted mb-1" data-testid="kw-serbest">
        {t("talepDetay.kwSerbest", { serbest: kwYazi(a.serbest, yerel) })}
      </div>
    );
  }

  const odeme = guvenliOdemeBaglantisi(kwKontrol?.odeme);
  return (
    <Alert color="warning" className="small py-2 mb-1" data-testid="kw-ucretli-uyari">
      <div>
        {t("talepDetay.kwUcretli", { kw: kwYazi(a.istenen, yerel), serbest: kwYazi(a.serbest, yerel), asan: kwYazi(a.asan, yerel) })}
      </div>
      {odeme && (
        <div className="mt-2 d-flex align-items-center gap-2 flex-wrap">
          <a href={odeme.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-warning" data-testid="kw-odeme-dugmesi">
            <ExternalLink size={14} className="me-1" />{odeme.etiket || t("talepDetay.odemeYap")}
          </a>
          <span className="text-muted" data-testid="kw-odeme-host">{t("talepDetay.odemeBaglantisiHost", { host: odeme.host })}</span>
        </div>
      )}
    </Alert>
  );
}
